import { render, staticRenderFns } from "./HealthTabs.vue?vue&type=template&id=008a352c&"
import script from "./HealthTabs.vue?vue&type=script&lang=ts&"
export * from "./HealthTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports